import one from '../../../assets/images/rating/1.svg';
import two from '../../../assets/images/rating/2.svg';
import three from '../../../assets/images/rating/3.svg';
import four from '../../../assets/images/rating/4.svg';
import five from '../../../assets/images/rating/5.svg';

type Image = { image: string; score: number; label: string };

export const smileys: Image[] = [
  {
    image: one,
    score: 1,
    label: '1 out of 5',
  },
  {
    image: two,
    score: 2,
    label: '2 out of 5',
  },
  {
    image: three,
    score: 3,
    label: '3 out of 5',
  },
  {
    image: four,
    score: 4,
    label: '4 out of 5',
  },
  {
    image: five,
    score: 5,
    label: '5 out of 5',
  },
];
